/**
 * Display names and the "contact us to enable this" copy live in the frontend —
 * the API returns keys only. Keys come from `GET /superadmin/features`; anything
 * not listed here still renders with a sensible fallback.
 */
export interface FeatureInfo {
  label: string;
  tagline: string;
  includes: string[];
}

export const FEATURE_CATALOG: Record<string, FeatureInfo> = {
  LOYALTY: {
    label: "Loyalty & Rewards",
    tagline:
      "Turn regulars into members — reward every booking and give clients a reason to come back.",
    includes: [
      "Points earned automatically on bookings and purchases",
      "Reward tiers and redeemable offers you define",
      "Point balances and history on every client profile",
      "Invite links that hand new clients their first points",
    ],
  },
  CLASSES: {
    label: "Classes & Coaching",
    tagline:
      "Run group sessions, coaching and multi-session packages alongside your normal bookings.",
    includes: [
      "Group classes with capacity, membership clients and attendance",
      "Recurring schedules — weekly, monthly or custom",
      "Coach profiles, session rates and payouts",
      "Class packages clients buy up front and draw down",
    ],
  },
  STOCK: {
    label: "Inventory",
    tagline:
      "Track what you sell — from the shelf to the invoice — without a second system.",
    includes: [
      "Products with sale prices and stock levels per branch",
      "Purchases from suppliers, with cost tracking",
      "A full movement history for every product",
      "Adding product lines straight onto invoices",
    ],
  },
};

export const getFeatureInfo = (key: string): FeatureInfo =>
  FEATURE_CATALOG[key] || {
    label:
      key.charAt(0) + key.slice(1).toLowerCase().replace(/_/g, " "),
    tagline: "This module is available on request.",
    includes: [],
  };
